module.exports = __webpack_public_path__ + "static/img/55.f83907e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/55.jpg
// module id = lb6W
// module chunks = 1